import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalAccount { 
  id: number; 
  name: string; 
  description?: string; 
  balance: number; 
  is_default?: boolean;
  is_investment?: boolean;
  created_at: string; 
  updated_at?: string;
  // Sync fields
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listAccounts() { return dbGetAll<LocalAccount>('accounts'); }

export function getAccountById(id: number) {
  return dbGetById<LocalAccount>('accounts', id);
}

export async function createAccount(data: Omit<LocalAccount,'id'|'created_at'|'updated_at'|'server_id'|'last_synced_at'|'needs_sync'>) {
  const now = new Date().toISOString();
  return dbAdd('accounts', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateAccount(id: number, data: Partial<LocalAccount>) {
  const current = await dbGetById<LocalAccount>('accounts', id);
  if (!current) throw new Error('Account not found');
  const updated = {
    ...current,
    ...data,
    id,
    // If caller passes updated_at (e.g. sync-from-server), preserve it
    updated_at: data.updated_at ?? new Date().toISOString(),
    // If caller explicitly sets needs_sync (e.g. sync-from-server), honor it
    needs_sync: data.needs_sync ?? true
  };
  await dbPut('accounts', updated);
  return updated;
}

export function removeAccount(id: number) { return dbDelete('accounts', id); }

export async function getAccountsNeedingSync(): Promise<LocalAccount[]> {
  const all = await dbGetAll<LocalAccount>('accounts');
  return all.filter(a => a.needs_sync === true);
}

export async function markSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalAccount>('accounts', id);
  if (!current) throw new Error('Account not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('accounts', current);
  return current;
}


